import React, { useContext } from 'react';

const SquareContext = React.createContext();

const { Provider, Consumer } = SquareContext;
export { Provider as SquareProvider, Consumer as SquareConsumer };
export default SquareContext;

export const useSquareContext = () => useContext(SquareContext);
